// Google Analytics utility functions
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// Track page views
export const trackPageView = (pagePath: string, pageTitle?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-BBVR3HELR6', {
      page_path: pagePath,
      page_title: pageTitle || document.title,
    });
  }
};

// Track add to cart events
export const trackAddToCart = (productData: {
  item_id: string;
  item_name: string;
  item_category?: string;
  price: number;
  quantity: number;
  currency?: string;
}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'add_to_cart', {
      currency: productData.currency || 'EUR',
      value: productData.price * productData.quantity,
      items: [{
        item_id: productData.item_id,
        item_name: productData.item_name,
        item_category: productData.item_category || 'Décoration Noël',
        price: productData.price,
        quantity: productData.quantity,
      }]
    });
  }
};

// Track view cart events
export const trackViewCart = (cartData: {
  currency?: string;
  value: number;
  items: Array<{
    item_id: string;
    item_name: string;
    item_category?: string;
    price: number;
    quantity: number;
  }>;
}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'view_cart', {
      currency: cartData.currency || 'EUR',
      value: cartData.value,
      items: cartData.items.map(item => ({
        item_id: item.item_id,
        item_name: item.item_name,
        item_category: item.item_category || 'Décoration Noël',
        price: item.price,
        quantity: item.quantity,
      }))
    });
  }
};

// Track begin checkout events
export const trackBeginCheckout = (checkoutData: {
  currency?: string;
  value: number;
  items: Array<{
    item_id: string;
    item_name: string;
    item_category?: string;
    price: number;
    quantity: number;
  }>;
}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'begin_checkout', {
      currency: checkoutData.currency || 'EUR',
      value: checkoutData.value,
      items: checkoutData.items.map(item => ({
        item_id: item.item_id,
        item_name: item.item_name,
        item_category: item.item_category || 'Décoration Noël',
        price: item.price,
        quantity: item.quantity,
      }))
    });
  }
};

// Track purchase events
export const trackPurchase = (purchaseData: {
  transaction_id: string;
  currency?: string;
  value: number;
  shipping?: number;
  tax?: number;
  items: Array<{
    item_id: string;
    item_name: string;
    item_category?: string;
    price: number;
    quantity: number;
  }>;
}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: purchaseData.transaction_id,
      currency: purchaseData.currency || 'EUR',
      value: purchaseData.value,
      shipping: purchaseData.shipping || 0,
      tax: purchaseData.tax || 0,
      items: purchaseData.items.map(item => ({
        item_id: item.item_id,
        item_name: item.item_name,
        item_category: item.item_category || 'Décoration Noël',
        price: item.price,
        quantity: item.quantity,
      }))
    });
  }
};

// Track product views
export const trackViewItem = (productData: {
  item_id: string;
  item_name: string;
  item_category?: string;
  price: number;
  currency?: string;
}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'view_item', {
      currency: productData.currency || 'EUR',
      value: productData.price,
      items: [{
        item_id: productData.item_id,
        item_name: productData.item_name,
        item_category: productData.item_category || 'Décoration Noël',
        price: productData.price,
        quantity: 1,
      }]
    });
  }
};

// Track custom events
export const trackCustomEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};